const React = require('react')
const Layout = require('./src/components/layout/Layout').default
require("./src/styles/global.css") 

require('@fontsource/oswald/600.css')
require('@fontsource/oswald/700.css')

exports.wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}